let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j0Njd")).then(() => parcelRequire('3HAKZ'));